import { Controller } from "@hotwired/stimulus"
import { TabulatorFull as Tabulator } from "tabulator-tables"

// Converteix un contenidor amb dades JSON en una taula Tabulator (ordenable,
// cercable i paginada del costat del client).
//
// Ús a la vista:
//   <div data-controller="tabulator"
//        data-tabulator-columns-value="<%= columns.to_json %>"
//        data-tabulator-rows-value="<%= rows.to_json %>">
//     <input data-tabulator-target="search" data-action="input->tabulator#search">
//     <div data-tabulator-target="table"></div>
//   </div>
export default class extends Controller {
  static targets = ["table", "search"]
  static values = {
    columns: Array,
    rows: Array,
    layout: { type: String, default: "fitColumns" },
    pageSize: { type: Number, default: 25 },
    placeholder: { type: String, default: "No hi ha cap registre." }
  }

  connect() {
    this.table = new Tabulator(this.tableTarget, {
      data: this.rowsValue,
      columns: this.columnsValue,
      layout: this.layoutValue,
      pagination: true,
      paginationSize: this.pageSizeValue,
      paginationSizeSelector: [25, 50, 100, true],
      paginationCounter: "rows",
      placeholder: this.placeholderValue,
      locale: "ca",
      langs: {
        ca: {
          pagination: {
            first: "Primera", last: "Última",
            prev: "Anterior", next: "Següent",
            page_size: "Per pàgina", counter: { showing: "Mostrant", of: "de", rows: "registres" }
          }
        }
      }
    })
  }

  disconnect() {
    this.table?.destroy()
    this.table = null
  }

  // Filtre global: cerca el text a tots els camps definits per a la cerca.
  search(event) {
    const term = event.target.value.toLowerCase().trim()
    const fields = this.columnsValue.filter((c) => c.field && c.searchable !== false).map((c) => c.field)

    if (!term) {
      this.table.clearFilter()
      return
    }

    this.table.setFilter((row) =>
      fields.some((field) => String(row[field] ?? "").toLowerCase().includes(term))
    )
  }
}
